module.exports = __webpack_public_path__ + "static/media/ProtocolOverview-icon.77ce6b30.svg";